// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".XvGeDWz8Uh3cnB {\n  cursor: pointer;\n  text-decoration: underline;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"showQrCodeLink": "XvGeDWz8Uh3cnB"
};
export default ___CSS_LOADER_EXPORT___;
